import { jsx as _jsx } from "preact/jsx-runtime";
import IconPage from '@fandom-frontend/react-common/dist/icons/IconPage';
import styles from '../styles/NoImage.module.scss';
export const NoImage = () => {
    return (_jsx("div", Object.assign({ className: styles.noImageWrapper }, { children: _jsx("div", Object.assign({ className: styles.iconWrapper }, { children: _jsx(IconPage, {}, void 0) }), void 0) }), void 0));
};
